import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, ButtonLoader, MessageService } from '../../../../core';
import { TokenfieldComponent } from '../../../../shared';
import { UsuarioEmailAdministrativoSelect, UsuarioEmailAdministrativoSelectComponent } from '../../../usuario/email/administrativo/select';
import { UsuarioEmailAssinaturaService } from '../../../usuario/email/services';
import { Email } from '../email';
import { EmailHttpService, EmailService } from '../services';

@Component({
    selector: 'sgt-send-email-modal',
    templateUrl: './send-email-modal.component.html',
    styleUrls: ['./send-email-modal.component.less']
})
export class SendEmailModalComponent implements OnInit {
    title: string;
    @Input() idModal: string;
    elModal: any;

    @ViewChild('form') form: NgForm;
    @ViewChild('toTokenfield') toTokenfield:  TokenfieldComponent;
    @ViewChild('inputSubject') inputSubject: ElementRef;
    @ViewChild('usuarioEmailAdministrativoSelect') usuarioEmailAdministrativoSelect: UsuarioEmailAdministrativoSelectComponent;

    email: Email;

    constructor(private el: ElementRef,
                private emailService: EmailService,
                private emailHttpService: EmailHttpService,
                private messageService: MessageService,
                private usuarioEmailAssinaturaService: UsuarioEmailAssinaturaService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.inputSubject.nativeElement).trigger('focus');
                // Removendo quais atributos disabled e readonly dos campos no form do e-mail, pois, quando abrir o modal dentro de um form bloqueado os campos do modal ficavam bloqueados também.
                this.elModal.find('.form-control').removeAttr('disabled', 'disabled').removeAttr('readonly', 'readonly');
                // Criando e-mail administrativos
                this.usuarioEmailAdministrativoSelect?.create();

                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                this.clear();
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    open(email: Email, title: string = 'Enviar e-mail') {
        // Title
        this.title = title;
        // Email
        this.email = email ?? {
            to: [],
            cc: [],
            subject: null,
            message: ''
        };
        this.email.message = this.email.message + this.emailService.createAssinaturaEmail(this.usuarioEmailAssinaturaService.getUrl());

        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    close() {
        this.elModal.modal('hide');
    }

    private clear() {
        this.form.resetForm();
        this.title = null;
        this.email = null;
    }

    /** Envia o e-mail */
    send() {
        const btnSendEmail = new ButtonLoader('#btnSendEmail');
        btnSendEmail.loading('Enviando E-mail');

        this.emailHttpService.send(this.email)
            .subscribe(
                response => {
                    this.messageService.success('', response);
                    btnSendEmail.reset();
                    this.close();
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao enviar o e-mail', error);
                    btnSendEmail.reset();
                }
            );
    }

    /** Ao selecionar ou não um e-mail administrativo do usuário */
    onToggleSelectUsuarioEmailAdministrativo(usuarioEmailAdministrativoSelect: UsuarioEmailAdministrativoSelect) {
        if (!usuarioEmailAdministrativoSelect) {
            return;
        }

        if (usuarioEmailAdministrativoSelect.selected) { // Selecionado
            this.toTokenfield.createToken(usuarioEmailAdministrativoSelect.email);
        } else { // Não selecionado
            this.toTokenfield.removeToken(usuarioEmailAdministrativoSelect.email);
        }
    }
}
